import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { redirectEventEmitter, redirectorKeys } from 'helpers/events'

export const useRedirector = () => {
    const history = useHistory()
    useEffect(() => {
        if (!history) return
        const handleRedirect = data => {
            history.push(data.path, {
                ...data,
            })
        }
        redirectEventEmitter.addListener(
            redirectorKeys.REDIRECT,
            handleRedirect
        )
        return () =>
            redirectEventEmitter.removeListener(
                redirectorKeys.REDIRECT,
                handleRedirect
            )
    }, [history])
}
